import { utils } from 'ethers'
import { Contract } from '@ethersproject/contracts'

import tokenSale from './tokenSale.json'

const contractInterface = new utils.Interface(tokenSale.abi)
const contractAddress = tokenSale.address
const tokenSaleContract = new Contract(contractAddress, contractInterface)
const tokenSaleAddress = tokenSale.address

export { tokenSaleContract, tokenSaleAddress }
